<div class="service">
    <request-service-list (selectedService)=setSelectedService($event)></request-service-list>
</div>
<div class="motive">
    <request-motives-selection class="motive-list" [selectedService]="selectedService"></request-motives-selection>
</div>